import type { ComponentType, CSSProperties, SVGProps } from 'react';

interface IconProps {
  kind: string;
  size?: number;
  className?: string;
  style?: CSSProperties;
}

// Eagerly load all icons as React components via vite-plugin-svgr
const iconModules = import.meta.glob('/src/assets/icons/*.svg', {
  eager: true,
  query: '?react',
  import: 'default'
}) as Record<string, ComponentType<SVGProps<SVGSVGElement>>>;

export default function Icon({ kind, size = 20, className, style }: IconProps) {
  const SvgComponent = iconModules[`/src/assets/icons/${kind}.svg`];

  if (!SvgComponent) {
    return null;
  }

  return (
    <SvgComponent
      className={['Icon', className].filter(Boolean).join(' ')}
      style={{
        display: 'block',
        width: `${size}px`,
        height: `${size}px`,
        ...style
      }}
    />
  );
}
